export default __webpack_public_path__ + "static/media/AboutBrief-02.43552259.jpg";